import { forwardRef } from 'react';
import { Input } from '@chakra-ui/react';
import { InputMask, InputMaskProps } from '@react-input/mask';

type MaskedInputProps = InputMaskProps;

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ mask, ...rest }, ref) => (
    <InputMask
      component={Input}
      ref={ref}
      mask={mask}
      replacement={{ _: /\d/ }}
      {...rest}
    />
  )
);
